import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LocationService {
    private apiUrl = environment.apiUrl + '/locations';

    constructor(private http: HttpClient) { }

    // Create new location
    createLocation(locationData: any): Observable<any> {
        return this.http.post(this.apiUrl, locationData);
    }

    // Get all locations with optional isActive filter
    getLocations(isActive?: boolean, includeChildren = false): Observable<any> {
        const params: any = {};
        if (isActive !== undefined) {
            params.isActive = isActive;
        }
        if (includeChildren) {
            params.includeChildren = true;
        }
        return this.http.get(this.apiUrl, { params });
    }

    // Get location by ID
    getLocationById(id: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/${id}`);
    }

    // Update location by ID
    updateLocation(id: string, locationData: any): Observable<any> {
        return this.http.patch(`${this.apiUrl}/${id}`, locationData);
    }

    // Create the store / warehouse record tagged to a location (POST /stores)
    createStore(storeData: any): Observable<any> {
        return this.http.post(environment.apiUrl + '/stores', storeData);
    }

    // Every store / warehouse record of the client, active and inactive, with its location
    getStores(): Observable<any> {
        return this.http.get(environment.apiUrl + '/stores');
    }

    // Edit store details or (de)activate it (PATCH /stores/:storeCode)
    updateStore(storeCode: string, storeData: any): Observable<any> {
        return this.http.patch(`${environment.apiUrl}/stores/${encodeURIComponent(storeCode)}`, storeData);
    }

    // Delete location (marks as inactive)
    deleteLocation(id: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${id}`);
    }
}
